import * as angular from "angular";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {WorkloadRequests} from "./workload-requests.service";
import {AccountModel} from "../../account/angular/models/account.model";
import {workLoadModel} from "../models/work-load.model";
import {WorkloadAlerts} from "./workload-alerts.service";
import {WorkLoadAgentWithShiftsModel} from "../models/work-load-agent-with-shifts.model";

export class WorkloadService {

  constructor(private $q: IQService, private workloadRequests: WorkloadRequests,
              private bringozLoaderService: BringozLoaderService,
              private workloadAlerts: WorkloadAlerts,
              private $log) {
  }

  getTotals(holderId: string, holderType: string, from, to) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.workloadRequests.getTotals(holderId, holderType, from, to)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        // this.expensesAlerts.getOneError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getWorkLoad(holderId: string, holderType: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.workloadRequests.getWorkLoad(holderId, holderType)
      .then((res: workLoadModel) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateWorkload(workLoadId: any, payload: workLoadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.workloadRequests.updateWorkLoad(workLoadId, payload)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  validateImport(file, intervalMinutes, holderId: string, holderType: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.workloadRequests.validateImport(file, intervalMinutes, holderId, holderType)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  import(workloadData) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.workloadRequests.import(workloadData)
      .then((res) => {
        this.workloadAlerts.updateSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.workloadAlerts.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getAttendanceState(holderId: string, holderType: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.workloadRequests.getAttendanceState(holderId, holderType)
      .then((res: WorkLoadAgentWithShiftsModel) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        // this.workloadAlerts.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getAttendanceFuture(holderId: string, holderType: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.workloadRequests.getAttendanceFuture(holderId, holderType)
      .then((res: WorkLoadAgentWithShiftsModel) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        // this.workloadAlerts.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.workload')
  .service('workloadService', WorkloadService);
